var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "icon-stroke",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.311 16.342a6.56 6.56 0 0 0 .939-.722 5.692 5.692 0 0 0 1.658-2.778 3.317 3.317 0 0 0-1.133-3.729 3.495 3.495 0 0 0-2.07-.64H17.04l-.148.64-1.893 8.1h4.466a5.41 5.41 0 0 0 2.845-.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.224 35.115L8.98 1.962h16.216c4.859 0 10.273 3.493 8.644 10.88a13.268 13.268 0 0 1-13.385 10.583H13.66l-2.916 11.69h-9.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.02 12.085a9.292 9.292 0 0 1 .708 6.644 13.153 13.153 0 0 1-13.099 10.536c-.618.012-6.421 0-7.042 0L16.627 41H7.11l.664-2.948"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPaypal);
export default __webpack_public_path__ + "static/media/payment-paypal.0bcfddf4.svg";
export { ForwardRef as ReactComponent };